import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import api from "../../Axios";
import Swal from "sweetalert2";

const UpdateContact = () => {
  const history = useHistory();
  const { id } = useParams();

  const [data, setData] = useState({
    phone: "",
    email: "",
    member1Mobile: "",
    member2Mobile: "",
  });

  const inputStyle = {
    border: "1.5px solid #757575",
    borderRadius: "12px",
    boxShadow: "none",
    outline: "none",
    fontWeight: "bold",
    color: "#333",
  };

  const labelStyle = {
    color: "#212121",
    fontWeight: "800",
    marginBottom: "6px",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.includes("phone") || name.includes("Mobile")) {
      if (/^\d*$/.test(value) && value.length <= 10) {
        setData({ ...data, [name]: value });
      }
    } else {
      setData({ ...data, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      userId: Number(id),
      phone: data.phone,
      email: data.email,
      member1Mobile: data.member1Mobile,
      member2Mobile: data.member2Mobile,
    };

    api
      .post("/admin/userProfile/contactUpdate/", payload)
      .then(() => {
        Swal.fire("Success", "Contact details updated", "success").then(() => {
          history.goBack();
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to update contact details", "error");
      });
  };

  useEffect(() => {
    api
      .get(`/admin/userProfile/profileView?userId=${id}`)
      .then((res) => {
        const d = res.data && res.data.data ? res.data.data : {};
        const profile = d.profile || {};
        const family = d.userFamily || {};
        setData({
          phone: profile.phone || "",
          email: profile.email || "",
          member1Mobile: family.member1Mobile || "",
          member2Mobile: family.member2Mobile || "",
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to load contact details", "error");
      });
  }, [id]);

  return (
    <div style={{ background: "#fff", marginTop: "70px" }}>
      <div
        style={{
          color: "#1a237e",
          fontWeight: "900",
          padding: "20px 10px",
        }}
      >
        <h4 style={{ fontSize: "1.8rem" }}>Update Contact Details</h4>
      </div>

      <Form
        onSubmit={handleSubmit}
        style={{ padding: 24, maxWidth: 1200, margin: "0 10px" }}
      >
        <FormGroup>
          <Label style={labelStyle}>Phone Number</Label>
          <Input
            type="text"
            name="phone"
            value={data.phone}
            onChange={handleChange}
            placeholder="Enter phone number"
            style={inputStyle}
          />
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Email ID</Label>
          <Input
            type="email"
            name="email"
            value={data.email}
            onChange={handleChange}
            placeholder="Enter email address"
            style={inputStyle}
          />
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Father's Mobile Number</Label>
          <Input
            type="text"
            name="member1Mobile"
            value={data.member1Mobile}
            onChange={handleChange}
            placeholder="Enter father's mobile number"
            style={inputStyle}
          />
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Mother's Mobile Number</Label>
          <Input
            type="text"
            name="member2Mobile"
            value={data.member2Mobile}
            onChange={handleChange}
            placeholder="Enter mother's mobile number"
            style={inputStyle}
          />
        </FormGroup>

        <Button
          type="submit"
          style={{
            width: "30%",
            borderRadius: 8,
            backgroundColor: "#000",
            color: "#fff",
            fontWeight: "bold",
            padding: "10px 0",
          }}
        >
          Save & Continue
        </Button>
      </Form>
    </div>
  );
};

export default UpdateContact;
